import { useCallback } from 'react';

import isEqual from 'fast-deep-equal';

import { useAppSelector } from 'hooks/store';
import { selectRoles } from 'store/selectors';
import { IMenuItem } from 'types/menu';

export const useIsAccessible = () => {
  const userRoles = useAppSelector(selectRoles, isEqual);

  return useCallback(
    ({ includeInMenu, roles }: IMenuItem) =>
      includeInMenu && userRoles?.some((role) => roles.includes(role.toLowerCase())),
    [userRoles]
  );
};
